import axios from "axios";
import { API_GET_BRAND_DATA, API_INSERT_BRAND_DATA, API_TOGGLE_BRAND_DATA, API_UPDATE_BRAND_DATA } from ".";

export const getBrandsList = async (func, config) => {
    return axios.get(API_GET_BRAND_DATA, config).then(res => func(res.data.data));
}

export const insertBrandData = async (data, config) => {
    return axios.post(API_INSERT_BRAND_DATA, data, config).then((res) => res.data);
};

export const updateBrandData = async (data, config) => {
    return axios.put(API_UPDATE_BRAND_DATA, data, config).then((res) => res.data);
};

export const toggleBrandData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_BRAND_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};